// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__D06V6","col":"styles_col__epazn"};